import { ItandiChip } from "@itandi/itandi-bb-ui";
import type React from "react";
import Styles from "./FormRow.module.scss";

type Props = {
	children: React.ReactNode;
	error?: string;
	label: string;
	required?: boolean;
};

export const FormRow: React.FC<Props> = ({
	label,
	required,
	error,
	children
}) => (
	<div className={Styles.FormRow}>
		<div className={Styles.FormLabel}>
			<span className={Styles.FormLabelText}>{label}</span>
			{required ? (
				<span className={Styles.RequiredLabel}>
					<ItandiChip label="必須" />
				</span>
			) : null}
		</div>
		<div className={Styles.FormContent}>
			{children}
			{error ? <div className={Styles.ErrorMessage}>{error}</div> : null}
		</div>
	</div>
);
